// extracted by mini-css-extract-plugin
export default {"container":"sideicon_container__1MH-G"};